import { useMemo, useState } from 'react';
import { faqCategories, faqItems } from '@/mocks/home';

export default function FaqSection() {
  const [category, setCategory] = useState('all');
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const filtered = useMemo(() => {
    const list = category === 'all' ? faqItems : faqItems.filter((item) => item.category === category);
    return list;
  }, [category]);

  const handleCategory = (key: string) => {
    setCategory(key);
    setOpenIndex(0);
  };

  return (
    <section id="faq" className="scroll-mt-24 bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 text-xs md:text-sm text-primary-700 bg-primary-100 px-3 py-1.5 rounded-full">
            <i className="ri-question-line"></i>
            常见问题
          </span>
          <h2 className="mt-4 font-heading text-2xl md:text-4xl text-foreground-950 leading-snug">
            关于入口与地址的高频疑问
          </h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-foreground-700">
            按主题筛选，看看有没有和你情况相近的问题。点开每一条即可查看完整解答，再次点击可以收起。
          </p>
        </div>

        <div className="mt-8 flex flex-wrap gap-2">
          {faqCategories.map((cat) => (
            <button
              key={cat.key}
              type="button"
              onClick={() => handleCategory(cat.key)}
              aria-pressed={category === cat.key}
              className={`px-4 py-2 rounded-full text-sm transition-colors cursor-pointer whitespace-nowrap border ${
                category === cat.key
                  ? 'bg-secondary-500 text-background-50 border-secondary-500'
                  : 'bg-background-50 text-foreground-700 border-background-300/70 hover:border-secondary-300'
              }`}
            >
              {cat.label}
            </button>
          ))}
        </div>

        <div className="mt-8 max-w-4xl space-y-3">
          {filtered.map((item, index) => {
            const open = openIndex === index;
            return (
              <div
                key={item.q}
                className="rounded-lg bg-background-50 border border-background-200/70 overflow-hidden"
              >
                <button
                  type="button"
                  onClick={() => setOpenIndex(open ? null : index)}
                  aria-expanded={open}
                  className="w-full flex items-start justify-between gap-4 px-5 md:px-6 py-5 text-left cursor-pointer hover:bg-primary-50/60 transition-colors"
                >
                  <span className="flex items-start gap-3">
                    <span className="w-6 h-6 shrink-0 flex items-center justify-center rounded-md bg-secondary-100 text-secondary-700 text-xs font-medium mt-0.5">
                      Q
                    </span>
                    <span className="font-medium text-sm md:text-base text-foreground-950">{item.q}</span>
                  </span>
                  <i
                    className={`mt-1 text-lg text-foreground-500 transition-transform duration-300 ${
                      open ? 'ri-subtract-line' : 'ri-add-line'
                    }`}
                  ></i>
                </button>
                <div
                  className={`px-5 md:px-6 transition-all duration-300 overflow-hidden ${
                    open ? 'max-h-96 pb-6 opacity-100' : 'max-h-0 opacity-0'
                  }`}
                >
                  <div className="flex items-start gap-3 pl-0 md:pl-9">
                    <p className="text-sm leading-relaxed text-foreground-700">{item.a}</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {filtered.length === 0 && (
          <p className="mt-8 text-sm text-foreground-600">该分类下暂时没有内容，换个分类看看吧。</p>
        )}
      </div>
    </section>
  );
}